import { api } from '@api/api2';

export const getTypesResidentsImport = () =>
  api.v4('get', 'residents-new/support/available-resident-import-type');
